module.exports = __webpack_public_path__ + "img/1503906211.23424d8d.jpg";